/**
 * LevelBadge - color-coded DEBUG / INFO / WARNING / ERROR / CRITICAL pill
 * used in the admin log viewer (Phase 12.3).
 *
 * Color mapping is per SPEC §9 AdminLogsPage:
 *   DEBUG    -> neutral
 *   INFO     -> blue (info)
 *   WARNING  -> amber (warning)
 *   ERROR    -> red (error)
 *   CRITICAL -> red + bold
 */
import { Badge } from "@/components/ui";
import type { BadgeProps } from "@/components/ui/Badge";
import type { LogLevel } from "@/types/api";

interface LevelBadgeProps {
  level: LogLevel;
}

const VARIANT: Record<LogLevel, BadgeProps["variant"]> = {
  DEBUG: "default",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
  CRITICAL: "error",
};

export function LevelBadge({ level }: LevelBadgeProps): JSX.Element {
  const isCritical = level === "CRITICAL";
  return (
    <Badge
      variant={VARIANT[level]}
      className={isCritical ? "font-bold uppercase tracking-wide" : undefined}
    >
      {level}
    </Badge>
  );
}

export default LevelBadge;
